/* TailorTail Co — Cart Drawer */

(function() {
  'use strict';

  var drawer = document.querySelector('[data-cart-drawer]');
  var overlay = document.querySelector('[data-cart-drawer-overlay]');
  if (!drawer || !overlay) return;

  var previousFocus = null;

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  // ─── Open / Close ───

  function openDrawer() {
    previousFocus = document.activeElement;
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    drawer.querySelector('[data-cart-drawer-close]').focus();
    refreshDrawer();
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    if (previousFocus) previousFocus.focus();
  }

  // Expose globally
  window.TailorTail = window.TailorTail || {};
  window.TailorTail.openCartDrawer = openDrawer;
  window.TailorTail.closeCartDrawer = closeDrawer;

  // ─── Event Bindings ───

  // Close buttons
  document.querySelectorAll('[data-cart-drawer-close]').forEach(function(btn) {
    btn.addEventListener('click', closeDrawer);
  });

  // Overlay click
  overlay.addEventListener('click', closeDrawer);

  // Escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
      closeDrawer();
    }
  });

  // Cart icon in header opens drawer
  var cartTriggers = document.querySelectorAll('[data-cart-drawer-trigger]');
  cartTriggers.forEach(function(trigger) {
    trigger.addEventListener('click', function(e) {
      e.preventDefault();
      openDrawer();
    });
  });

  // ─── AJAX Cart Operations ───

  function updateCartItem(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function(res) { return res.json(); });
  }

  function addToCart(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
    }).then(function(res) { return res.json(); });
  }

  function getCart() {
    return fetch('/cart.js', {
      headers: { 'Content-Type': 'application/json' }
    }).then(function(res) { return res.json(); });
  }

  // ─── Render Drawer from Cart JSON ───

  function refreshDrawer() {
    getCart().then(function(cart) {
      renderDrawer(cart);
      if (window.TailorTail && window.TailorTail.updateCartCount) {
        window.TailorTail.updateCartCount(cart.item_count);
      }
    });
  }

  function renderDrawer(cart) {
    // Update count
    var countEl = drawer.querySelector('[data-cart-drawer-count]');
    if (countEl) countEl.textContent = '(' + cart.item_count + ')';

    // Update subtotal
    var subtotalEl = drawer.querySelector('[data-cart-drawer-subtotal]');
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

    // Update shipping bar
    var shippingBar = drawer.querySelector('[data-cart-drawer-shipping]');
    if (shippingBar) {
      var threshold = parseInt(shippingBar.getAttribute('data-threshold'), 10);
      var remaining = threshold - cart.total_price;
      var progress = remaining <= 0 ? 100 : Math.round((cart.total_price / threshold) * 100);
      var fill = shippingBar.querySelector('[data-cart-drawer-shipping-fill]');
      var msg = shippingBar.querySelector('[data-cart-drawer-shipping-msg]');
      if (fill) fill.style.width = progress + '%';
      if (msg) {
        if (remaining <= 0) {
          msg.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><polyline points="20 6 9 17 4 12"/></svg> You\'ve earned FREE shipping!';
        } else {
          msg.textContent = 'You\'re ' + formatMoney(remaining) + ' away from FREE shipping!';
        }
      }
    }

    // Update item-count free shipping upsell
    var itemUpsell = drawer.querySelector('[data-cart-item-upsell]');
    if (itemUpsell) {
      var itemThreshold = parseInt(itemUpsell.getAttribute('data-item-threshold'), 10) || 2;
      var upsellMsg = itemUpsell.getAttribute('data-item-upsell-msg');
      var reachedMsg = itemUpsell.getAttribute('data-item-upsell-reached-msg');
      itemUpsell.hidden = cart.item_count === 0;
      if (cart.item_count > 0 && cart.item_count < itemThreshold) {
        itemUpsell.innerHTML = '<span class="cart-drawer__item-upsell-icon">🎁</span>' + upsellMsg;
        itemUpsell.classList.remove('is-reached');
      } else if (cart.item_count >= itemThreshold) {
        itemUpsell.innerHTML = '<span class="cart-drawer__item-upsell-icon">✓</span>' + reachedMsg;
        itemUpsell.classList.add('is-reached');
      }
    }

    // Render items
    var itemsContainer = drawer.querySelector('[data-cart-drawer-items]');
    var emptyContainer = drawer.querySelector('[data-cart-drawer-empty]');
    var footer = drawer.querySelector('[data-cart-drawer-footer]');
    var addonsSection = drawer.querySelector('[data-cart-drawer-addons]');

    if (cart.item_count === 0) {
      if (itemsContainer) itemsContainer.style.display = 'none';
      if (addonsSection) addonsSection.style.display = 'none';
      if (footer) footer.style.display = 'none';
      if (emptyContainer) emptyContainer.style.display = '';
      updateSavings(cart);
      return;
    }

    if (emptyContainer) emptyContainer.style.display = 'none';
    if (itemsContainer) itemsContainer.style.display = '';
    if (footer) footer.style.display = '';
    filterAddons(cart);

    if (itemsContainer) {
      var html = '';
      cart.items.forEach(function(item) {
        var variantLabel = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
        var propsHtml = '';
        var photoThumbsHtml = '';
        if (item.properties) {
          Object.keys(item.properties).forEach(function(key) {
            if (key.indexOf('Pet Photo') !== -1) {
              var photoVal = item.properties[key];
              if (photoVal) photoThumbsHtml += '<div class="cart-drawer__pet-thumb"><img src="' + photoVal + '" alt="Pet photo" width="40" height="40"></div>';
              return;
            }
            if (key === '_Bundle Size' || key === '_Bundle Discount') return;
            var val = item.properties[key];
            if (val) propsHtml += '<span class="cart-drawer__item-property">' + key + ': ' + val + '</span>';
          });
        }

        var imgSrc = item.image || '';

        html += '<div class="cart-drawer__item" data-cart-drawer-item="' + item.key + '">' +
          '<div class="cart-drawer__item-image"><img src="' + imgSrc + '" alt="" width="64" height="64" loading="lazy"></div>' +
          '<div class="cart-drawer__item-details">' +
            '<p class="cart-drawer__item-title">' + item.product_title + '</p>' +
            (variantLabel ? '<span class="cart-drawer__item-variant">' + variantLabel + '</span>' : '') +
            propsHtml +
            photoThumbsHtml +
            '<div class="cart-drawer__item-actions">' +
              '<button class="cart-drawer__qty-btn" data-cart-drawer-qty-minus="' + item.key + '" aria-label="Decrease quantity">−</button>' +
              '<span class="cart-drawer__qty-value" data-cart-drawer-qty-val="' + item.key + '">' + item.quantity + '</span>' +
              '<button class="cart-drawer__qty-btn" data-cart-drawer-qty-plus="' + item.key + '" aria-label="Increase quantity">+</button>' +
            '</div>' +
          '</div>' +
          '<div class="cart-drawer__item-right">' +
            '<span class="cart-drawer__item-price">' + formatMoney(item.final_line_price) + '</span>' +
            '<button class="cart-drawer__item-remove" data-cart-drawer-remove="' + item.key + '" aria-label="Remove"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button>' +
          '</div>' +
        '</div>';
      });
      itemsContainer.innerHTML = html;
      bindItemEvents();
    }

    updateSavings(cart);
  }

  // ─── Add-On Visibility Rules ───

  function filterAddons(cart) {
    var addonsSection = drawer.querySelector('[data-cart-drawer-addons]');
    if (!addonsSection) return;

    var cards = addonsSection.querySelectorAll('.cart-drawer__addon-card');
    var collectionMap = {};
    var mapEl = document.querySelector('[data-addon-collection-map]');
    if (mapEl) {
      try { collectionMap = JSON.parse(mapEl.textContent); } catch(e) {}
    }

    var cartProductIds = cart.items.map(function(item) { return item.product_id; });
    var cartProductTypes = cart.items.map(function(item) { return (item.product_type || '').toLowerCase(); });

    var visibleCount = 0;
    cards.forEach(function(card) {
      var addonProductId = parseInt(card.getAttribute('data-addon-product-id'), 10);

      if (cartProductIds.indexOf(addonProductId) !== -1) {
        card.style.display = 'none';
        return;
      }

      var triggerProductId = card.getAttribute('data-addon-trigger-product-id');
      var triggerCollection = card.getAttribute('data-addon-trigger-collection');
      var triggerType = (card.getAttribute('data-addon-trigger-product-type') || '').toLowerCase();
      var hasRules = !!(triggerProductId || triggerCollection || triggerType);

      if (!hasRules && card.getAttribute('data-addon-show-always') === 'true') {
        card.style.display = '';
        visibleCount++;
        return;
      }

      if (!hasRules) {
        card.style.display = 'none';
        return;
      }

      var results = [];
      if (triggerProductId) {
        results.push(cartProductIds.indexOf(parseInt(triggerProductId, 10)) !== -1);
      }
      if (triggerCollection && collectionMap[triggerCollection]) {
        results.push(cartProductIds.some(function(id) {
          return collectionMap[triggerCollection].indexOf(id) !== -1;
        }));
      }
      if (triggerType) {
        results.push(cartProductTypes.indexOf(triggerType) !== -1);
      }

      var visible = results.some(function(r) { return r; });
      card.style.display = visible ? '' : 'none';
      if (visible) visibleCount++;
    });

    addonsSection.style.display = visibleCount > 0 ? '' : 'none';
  }

  // ─── Savings ───

  function updateSavings(cart) {
    var savingsEl = drawer.querySelector('[data-cart-drawer-savings]');
    var totalSavings = 0;

    // Bundle discount from properties
    if (cart.items) {
      cart.items.forEach(function(item) {
        if (item.properties && item.properties['_Bundle Discount']) {
          totalSavings += Math.round(parseFloat(item.properties['_Bundle Discount']) * 100);
        }
      });
    }

    // Sale savings (compare-at vs actual)
    if (cart.original_total_price && cart.total_price) {
      totalSavings += (cart.original_total_price - cart.total_price);
    }

    if (totalSavings > 0) {
      if (savingsEl) {
        savingsEl.style.display = '';
        var textEl = savingsEl.querySelector('.cart-drawer__savings-text');
        if (textEl) textEl.textContent = 'You\'re saving ' + formatMoney(totalSavings) + '!';
      } else {
        var footer = drawer.querySelector('[data-cart-drawer-footer]');
        if (footer) {
          var savingsHtml = '<div class="cart-drawer__savings" data-cart-drawer-savings>' +
            '<span class="cart-drawer__savings-icon"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><polyline points="20 6 9 17 4 12"/></svg></span>' +
            '<p class="cart-drawer__savings-text">You\'re saving ' + formatMoney(totalSavings) + '!</p>' +
          '</div>';
          footer.insertAdjacentHTML('beforebegin', savingsHtml);
        }
      }
    } else {
      if (savingsEl) savingsEl.style.display = 'none';
    }
  }

  // ─── Item Event Bindings (re-bound after render) ───

  function bindItemEvents() {
    // Quantity minus
    drawer.querySelectorAll('[data-cart-drawer-qty-minus]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var key = this.getAttribute('data-cart-drawer-qty-minus');
        var valEl = drawer.querySelector('[data-cart-drawer-qty-val="' + key + '"]');
        var qty = parseInt(valEl.textContent, 10) - 1;
        if (qty < 0) qty = 0;
        updateCartItem(key, qty).then(function(cart) { renderDrawer(cart); updateGlobalCount(cart); });
      });
    });

    // Quantity plus
    drawer.querySelectorAll('[data-cart-drawer-qty-plus]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var key = this.getAttribute('data-cart-drawer-qty-plus');
        var valEl = drawer.querySelector('[data-cart-drawer-qty-val="' + key + '"]');
        var qty = parseInt(valEl.textContent, 10) + 1;
        updateCartItem(key, qty).then(function(cart) { renderDrawer(cart); updateGlobalCount(cart); });
      });
    });

    // Remove
    drawer.querySelectorAll('[data-cart-drawer-remove]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var key = this.getAttribute('data-cart-drawer-remove');
        updateCartItem(key, 0).then(function(cart) { renderDrawer(cart); updateGlobalCount(cart); });
      });
    });
  }

  function updateGlobalCount(cart) {
    if (window.TailorTail && window.TailorTail.updateCartCount) {
      window.TailorTail.updateCartCount(cart.item_count);
    }
  }

  // ─── Add-On Variant Selector ───

  document.querySelectorAll('[data-cart-addon-variant]').forEach(function(select) {
    select.addEventListener('change', function() {
      var productId = this.getAttribute('data-cart-addon-variant');
      var option = this.options[this.selectedIndex];
      var price = parseInt(option.getAttribute('data-price'), 10);
      var variantId = option.value;

      var priceEl = drawer.querySelector('[data-cart-addon-price="' + productId + '"]');
      if (priceEl) priceEl.textContent = formatMoney(price);

      var addBtn = this.closest('.cart-drawer__addon-card').querySelector('[data-cart-addon-add]');
      if (addBtn) addBtn.setAttribute('data-cart-addon-add', variantId);
    });
  });

  // ─── Add-On Add to Cart ───

  document.querySelectorAll('[data-cart-addon-add]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var variantId = parseInt(this.getAttribute('data-cart-addon-add'), 10);
      var originalText = this.textContent;
      this.disabled = true;
      this.textContent = 'Adding...';

      addToCart(variantId, 1).then(function() {
        return getCart();
      }).then(function(cart) {
        renderDrawer(cart);
        updateGlobalCount(cart);
        btn.disabled = false;
        btn.textContent = 'Added!';
        setTimeout(function() { btn.textContent = originalText; }, 1500);
      }).catch(function() {
        btn.disabled = false;
        btn.textContent = originalText;
      });
    });
  });

  // Bind initial item events (for server-rendered items)
  bindItemEvents();
})();
